import { RADIO, CHECKBOX } from 'src/containers/AddSkuPage/QuestionsFlowPage/constants';
import { BRANDS, BRAND_TYPES, SKU_CONFIG_IDS } from 'src/containers/AddSkuPage/QuestionsFlowPage/skudata/constants';
/**
 *  OUR DECISION is fairly base. We seperated it out in answers and the decisionTree.
 *  Our decision tree will merge answer behaviors w/ the answer proper. Any overrides will happen in
 *  the decision tree.
 *  1. Add any 'new' answers
 *     i. if same answer id's have different values, that is ok, the tree will handle the override in the groups.
 *  2. Apply that answer to a question. What group is it part of? No seperate groups will default to group A.
 *
 */
const sku = SKU_CONFIG_IDS[1034];

export const answers = {
  ...BRANDS,
  ...BRAND_TYPES(4172, sku),
  [sku[10404]]: { id: sku[10404], label: 'Something\'s wrong with my computer', value: 0},
  [sku[10405]]: { id: sku[10405], label: 'Software installation', value: 0},
  [sku[10406]]: { id: sku[10406], label: 'Email or online account support', value: 0 },
  [sku[10407]]: { id: sku[10407], label: 'Operating system installation', value: 0 },

  [sku[10409]]: { id: sku[10409], label: 'Peripheral devices not working', value: 0 },
  [sku[10410]]: { id: sku[10410], label: 'Attachments won\'t open', value: 0 },
  [sku[10411]]: { id: sku[10411], label: 'Getting error messages/pop-ups', value: 0 },
  [sku[10412]]: { id: sku[10412], label: 'Files are missing', value: 0 },
  [sku[10413]]: { id: sku[10413], label: 'Computer freezes', value: 0 },
  [sku[10414]]: { id: sku[10414], label: 'Slow navigation speeds', value: 0 },
  [sku[10415]]: { id: sku[10415], label: 'Apps running slowly', value: 0 },
  [sku[10416]]: { id: sku[10416], label: 'Apps won\'t install', value: 0 },
  [sku[10417]]: { id: sku[10417], label: 'Other', value: 0 },

  [sku[10418]]: { id: sku[10418], label: 'Single title', value: 0 },
  [sku[10419]]: { id: sku[10419], label: 'Software suite ($30)', value: 30 },
}

/**
 *  Decision Tree
 *
 *  Answers will live under 'children', slotted into a group. Default is A.
 *  Spread out the needed answers, and add:
 *  @param answerType - RADIO, CHECKBOX
 *  @param path - this is the question id the answer links to
 *  @param group - if there is a specific group within a question to link to.
 *
 *  Note: This decisionTree can have two outcomes based on remotePossinle
 */
export const decisionTree = () => {
  const baseTree = {
    [sku[4169]]: {
      id: sku[4169],
      label: 'What do you need help with?',
      answerType: RADIO,
      complete: false,
      required: true,
      children: {
        A: [
          { ...answers[sku[10404]], path: sku[4170], flowAdjustment: -1 },
          { ...answers[sku[10405]], path: sku[4171] },
          { ...answers[sku[10406]], path: 'brand', flowAdjustment: -2 },
          { ...answers[sku[10407]], path: 'brand', flowAdjustment: -2 },
        ]
      }
    },
    [sku[4171]]: {
      id: sku[4171],
      label: 'How much software will be installed?',
      answerType: RADIO,
      complete: false,
      required: true,
      children: {
        A: [
          { ...answers[sku[10418]], path: 'brand', flowAdjustment: -1 },
          { ...answers[sku[10419]], path: 'brand', flowAdjustment: -1 },
        ]
      }
    },
    [sku[4170]]: {
      id: sku[4170],
      label: 'What\'s wrong with your computer?',
      answerType: CHECKBOX,
      complete: false,
      required: true,
      hint: 'If your computer crashes/freezes right after startup or makes loud noises, please opt for an in-home computer support service.',
      children: {
        A: [
          { ...answers[sku[10409]], path: 'brand' },
          { ...answers[sku[10410]], path: 'brand' },
          { ...answers[sku[10411]], path: 'brand' },
          { ...answers[sku[10412]], path: 'brand' },
          { ...answers[sku[10413]], path: 'brand' },
          { ...answers[sku[10414]], path: 'brand' },
          { ...answers[sku[10415]], path: 'brand' },
          { ...answers[sku[10416]], path: 'brand' },
          { ...answers[sku[10417]], path: 'brand' },
        ]
      }
    },
    'brand' : {
      id: 'brand',
      label: 'What brand is your computer?',
      answerType: RADIO,
      idsToStopAdvancement: ['brandOther'],
      children: {
        A: [
          { ...answers.apple,     path: 'product', group: 'A' },
          { ...answers.google,    path: 'product', group: 'B' },
          { ...answers.lenovo,    path: 'product', group: 'C' },
          { ...answers.toshiba,   path: 'product', group: 'D' },
          { ...answers.asus,      path: 'product', group: 'E' },
          { ...answers.alienware, path: 'product', group: 'F' },
          { ...answers.razer,     path: 'product', group: 'G' },
          { ...answers.dell,      path: 'product', group: 'H' },
          { ...answers.hp,        path: 'product', group: 'I' },
          { ...answers.microsoft, path: 'product', group: 'J' },
          { ...answers.acer,      path: 'product', group: 'K' },
          { ...answers.sony,      path: 'product', group: 'L' },
          { ...answers.huawei,    path: 'product', group: 'M' },
          { ...answers.brandOther,     path: 'product', group: 'N', showInput: true },
        ]
      }
    },
    product: { // What type
      id: 'product',
      label: 'What type of computer is it?',
      complete: true,
      answerType: RADIO,
      children: {
        A: [
          { ...answers.desktopApple, path: '', complete: true },
          { ...answers.laptopApple,  path: '', complete: true },
        ],
        B: [
          { ...answers.desktopGoogle, path: '', complete: true },
          { ...answers.laptopGoogle,  path: '', complete: true },
        ],
        C: [
          { ...answers.desktopLenovo, path: '', complete: true },
          { ...answers.laptopLenovo,  path: '', complete: true },
        ],
        D: [
          { ...answers.desktopToshiba, path: '', complete: true },
          { ...answers.laptopToshiba,  path: '', complete: true },
        ],
        E: [
          { ...answers.desktopAsus, path: '', complete: true },
          { ...answers.laptopAsus,  path: '', complete: true },
        ],
        F: [
          { ...answers.desktopAlienware, path: '', complete: true },
          { ...answers.laptopAlienware,  path: '', complete: true },
        ],
        G: [
          { ...answers.desktopRazer, path: '', complete: true },
          { ...answers.laptopRazer,  path: '', complete: true },
        ],
        H: [
          { ...answers.desktopDell, path: '', complete: true },
          { ...answers.laptopDell,  path: '', complete: true },
        ],
        I: [
          { ...answers.desktopHP, path: '', complete: true },
          { ...answers.laptopHP,  path: '', complete: true },
        ],
        J: [
          { ...answers.desktopMicrosoft, path: '', complete: true },
          { ...answers.laptopMicrosoft,  path: '', complete: true },
        ],
        K: [
          { ...answers.desktopAcer, path: '', complete: true },
          { ...answers.laptopAcer,  path: '', complete: true },
        ],
        L: [
          { ...answers.desktopSony, path: '', complete: true },
          { ...answers.laptopSony,  path: '', complete: true },
        ],
        M: [
          { ...answers.laptopHuawei,  path: '', complete: true },
        ],
        N: [
          { ...answers.desktop,  path: '', complete: true },
          { ...answers.laptop,  path: '', complete: true },
        ]
      }
    }
  }

  return {
    seedQuestion: sku[4169],
    maxFlow: 5,
    ...baseTree
  }

};
